export default __webpack_public_path__ + "static/teemates_back-c21451773c1a145aee1f8e38374f71ff.webp";